define('adminKitProtsView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminKitProtsListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var KitProtListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'kitProtsListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteKitProt: '.delete-kitprot-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteKitProt': 'onDeleteKitProt'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'kitprots'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteKitProt: function(event){
            this.trigger('kitprot:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'kitprot-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code'
                    }, {
                        label: _.i18n('common.name'),
                        name: 'name',
                        classes: 'kitprot-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'name'
                    }, {
                        label: _.i18n('kitprot.resGraph'),
                        name: 'resGraph',
                        classes: 'kitprot-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'resGraph'
                    }, {
                        label: _.i18n('kitprot.channels'),
                        name: 'channels',
                        classes: 'kitprot-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'channels'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-kitprot-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'admin/kitprots' ?
                                App.getCurrentRoute() : 'admin/kitprots/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = KitProtListView;
});
